import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import JobDetails from "./pages/JobDetails";
import ATSLayout from "./layouts/ATSLayout";
import TemplateManagement from "./pages/TemplateManagement";
import ActivityLog from "./pages/ActivityLog";
import CandidateProfile from "./pages/CandidateProfile";
import DepartmentsList from "./pages/DepartmentsList";
import OrgChart from "./pages/OrgChart";
import TenantSettings from "./pages/TenantSettings";
import AiUsage from "./pages/AiUsage";
import PlatformCredits from "./pages/PlatformCredits";
import ReviewConsole from "./pages/ReviewConsole";
import RubricEditor from "./pages/RubricEditor";
import FolderAssessments from "../assessments/FolderAssessments";
import FoldersList from "../assessments/FoldersList";
import AssessmentQuestions from "../assessments/AssessmentQuestions";
import AssessmentReport from "../assessments/AssessmentReport";
import TakeAssessment from "../assessments/TakeAssessment";
import MyAssessments from "../assessments/MyAssessments";
import AssessmentResults from "../assessments/AssessmentResults";

// SOP Module imports (adjust the path if your files are elsewhere)
import SopFoldersList from "../assessments/SopFoldersList";
import SopFolderDetails from "../assessments/SopFolderDetails";
import SopEditor from "../assessments/SopEditor";
import SopViewer from "../assessments/SopViewer";

const ATSModule = () => {
  return (
    <ATSLayout>
      <Routes>
        {/* Existing ATS routes */}
        <Route path="/ats" element={<Dashboard />} />
        <Route path="/ats/job/:job_id" element={<JobDetails />} />
        <Route path="/ats/templates" element={<TemplateManagement />} />
        {/* One candidate, one page, at every stage — identity, screening,
            the interview when there is one, notes and the audit trail. This
            replaced a 55%-wide drawer and the interview-only review console,
            which 404'd for any candidate who had not interviewed. */}
        <Route path="/ats/candidate/:application_id" element={<CandidateProfile />} />

        {/* The old review-console path, kept so existing links and bookmarks
            still land somewhere. It pointed at an interview-only screen; the
            candidate page above is a superset of it. */}
        <Route path="/ats/review/:application_id" element={<CandidateProfile />} />

        {/* What the team did, day by day, across every job. */}
        <Route path="/ats/activity" element={<ActivityLog />} />
        {/* One canvas, two scopes: every department, or one in focus. It
            replaced the two-pane tree-and-tabs builder. */}
        <Route path="/ats/org" element={<OrgChart />} />
        {/* The editable side. These are the same `departments` rows the ticket
            screens read — migration 017 folded the hierarchy into that table. */}
        <Route path="/ats/departments" element={<DepartmentsList />} />
        <Route path="/ats/departments/:deptId" element={<OrgChart />} />
        <Route path="/ats/settings" element={<TenantSettings />} />
        {/* Spend reporting for the hiring AI. Read-only. */}
        <Route path="/ats/ai-usage" element={<AiUsage />} />
        {/* Kumudu only. The API returns 404 for anyone else, so a customer
            who guesses the URL sees an empty page rather than a locked one. */}
        <Route path="/ats/credits" element={<PlatformCredits />} />
        {/* What the AI interview actually assesses: competencies, their
            weights, the 1/3/5 anchors and the hard gates. Editing writes a new
            version, so scores stay comparable to the anchors that produced
            them. Every job gets a generic starter rubric on creation — this is
            where it stops being generic. */}
        <Route path="/ats/rubric/:stage_id" element={<RubricEditor />} />

        {/* Review console for one candidate's AI interview. */}
        <Route
          path="/ats/review/:application_id"
          element={<ReviewConsole />}
        />

        {/* Assessment Module */}
        <Route path="/ats/assessments" element={<FoldersList />} />
        <Route
          path="/ats/assessments/folder/:folderId"
          element={<FolderAssessments />}
        />
        <Route
          path="/ats/assessments/assessment/:assessmentId/questions"
          element={<AssessmentQuestions />}
        />
        <Route path="/ats/assessments/report" element={<AssessmentReport />} />
        <Route path="/ats/my-assessments" element={<MyAssessments />} />
        <Route
          path="/ats/assessments/take/:assignmentId"
          element={<TakeAssessment />}
        />
        <Route
          path="/ats/assessments/results/:assignmentId"
          element={<AssessmentResults />}
        />

        {/* SOP / Training Module */}
        <Route path="/ats/sop" element={<SopFoldersList />} />
        <Route
          path="/ats/sop/folder/:folderId"
          element={<SopFolderDetails />}
        />
        <Route path="/ats/sop/folder/:folderId/new" element={<SopEditor />} />
        <Route path="/ats/sop/edit/:sopId" element={<SopEditor />} />
        <Route path="/ats/sop/view/:sopId" element={<SopViewer />} />
      </Routes>
    </ATSLayout>
  );
};

export default ATSModule;
